export const useIssues = () => {
  const findIssueByQuestionUuid = (issues: Array<{ inspection_question_uuid: string }>, QuestionUuid: string) => {
    return issues.find((issue: { inspection_question_uuid: string }) => {
      const splitUuid = issue.inspection_question_uuid ? issue.inspection_question_uuid.split('-') : [];
      const uuid = splitUuid.slice(1, 6).join('-');

      return uuid === QuestionUuid;
    });
  };

  const findIssueByKey = (issues: Record<string, unknown>, uuid: string) => Object
    .keys(issues)
    .find(key => key === uuid);

  return {
    findIssueByQuestionUuid,
    findIssueByKey,
  };
};
